import React, { useEffect, useState } from "react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/shadcn/ui/card";
import Autoplay from "embla-carousel-autoplay"
import { CalendarDays, Users, DollarSign, ArrowUp10, TrendingUp } from "lucide-react";
import { ResponsiveContainer, PieChart, Pie, Cell, BarChart, Bar, XAxis, Tooltip, Label, CartesianGrid, YAxis, Legend } from "recharts";
import useDashboard from "@/hook/useDashboard";
import { ChartContainer, ChartTooltip, ChartTooltipContent, ChartConfig } from "@/components/shadcn/ui/chart";
import { Carousel, CarouselContent, CarouselItem } from "@/components/shadcn/ui/carousel";
import { Skeleton } from "@/components/shadcn/ui/skeleton";
import CustomTooltip from "@/utils/customTooltip";
import CustomTooltipDeploy from "@/utils/customTooltipdeploy";



const COLOR_BY_DESCRIPTION: Record<string, string> = {
  "Aprovados": "#00C49F",
  "Aprovadas": "#00C49F",
  "Levantamento": "#283593",
  "Cancelados": "#8E1600",
  "Canceladas": "#8E1600",
  "Lead": "#0088FE",
  "Proposta": "#FFBB28",
  "Negociação": "#FFBB28",
  "Fechado": "#00C49F",
  "Sem descrição": "#AAAAAA",
  "Declinados": "#FB8C00"
};
type PipelineStage = {
  description: string;
  totalPrice: number;
  totalDeploy: number;
  count: number;
};

type countStage = {
  count: number;
  description: string;
  opportunityFlowId: number;
}

export default function CRMDashboard() {
  const [chartData, setChartData] = useState<countStage[]>([]);
  const [pipelineDataF, setPipelineDataF] = useState<PipelineStage[]>([]);
  const chartConfig = {
    desktop: {
      label: "Desktop",
      color: "#2563eb",
    },
    mobile: {
      label: "Mobile",
      color: "#60a5fa",
    },
  } satisfies ChartConfig
  const [sumImplantacao, setSumImplantacao] = useState(0);
  const [sumMensalidade, setSumMensalidade] = useState(0);
  const [percentImplant, setPercentImplant] = useState();
  const [atrasados, setAtrasados] = useState(0);
  const [pendentes, setPendentes] = useState(0);
  const [lateAprovados, setLateAprovados] = useState(0);
  const [lateRejeitados, setLateRejeitados] = useState(0);
  const [lateDeclined, setLateDeclined] = useState(0);
  const [loading, setLoading] = useState(false);
  const [aprovados, setAprovados] = useState(0);
  const [cancelados, setCancelados] = useState(0);
  const [declinados, setDeclinados] = useState(0);
  const [percentMens, setPercentMens] = useState();
  const currentYear = new Date().getFullYear();
  const years = Array.from(new Array(10), (val, index) => currentYear - 5 + index);
  const months = [
    "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
  ];
  const [month, setMonth] = useState(new Date().getMonth());
  const [year, setYear] = useState(currentYear);
  const [contagem, setContagem] = useState(0);
  const { getCountBusiness, getSumBusiness, getCountByGroup, getFinished, getPendentes, getSumByGroup } = useDashboard();
  const configDash = async (month: number, year: number) => {
    setLoading(true);
    try {
      const response = await getCountBusiness(month, year);
      const response2 = await getSumBusiness(month, year);
      const response3 = await getCountByGroup(month, year);
      const response4 = await getFinished(month, year);
      const response5 = await getPendentes(month, year);
      const response6 = await getSumByGroup(month, year);
      if (response6 != undefined) { setPipelineDataF(response6.data)}
      if (response4 != undefined) {setAprovados(response4.data.approved); setCancelados(response4.data.canceled); setDeclinados(response4.data.declined) }
      if (response5 != undefined) {
        setAtrasados(response5.data.atrasadas);
        setPendentes(response5.data.pendentes);
        setLateAprovados(response5.data.aprovadoAtrasado);
        setLateRejeitados(response5.data.rejeitadoAtrasado);
        setLateDeclined(response5.data.declinadoAtrasado)
      }
      if (response3 != undefined) { setChartData(response3.data) }
      if (response != undefined) { setContagem(response.count) }
      if (response2 != undefined) {
        setSumImplantacao(response2.data.sumImplantacaoAtual);
        setSumMensalidade(response2.data.sumPrecoAtual);
        setPercentImplant(response2.data.percentImplantacao);
        setPercentMens(response2.data.percentPreco);
      }
    } catch (e) {
      return;
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    configDash(month, year);
  }, []);

  useEffect(() => {
    configDash(month, year);
  }, [month, year]);

  return (
    <div className="p-6 space-y-6 bg-indigo-200 min-h-screen 2xl:h-screen ">
      <div className='flex justify-between'>
        <h1 className="text-2xl font-bold">Dashboard</h1>
        <form className="gap-4 flex flex-row justify-end">
          <div>
            <label htmlFor="countries" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Mês :</label>
            <select id="countries" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" value={month} onChange={(e) => setMonth(Number(e.target.value))}>
              {months.map((m, index) => (
                <option key={index} value={index}>{m}</option>
              ))}
            </select>
          </div>
          <div>
            <label htmlFor="countries" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Ano :</label>
            <select id="countries" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" value={year} onChange={(e) => setYear(Number(e.target.value))}>
              {years.map((y) => (
                <option key={y} value={y}>{y}</option>
              ))}
            </select>
          </div>
        </form>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card className='rounded-lg border bg-card text-card-foreground shadow-sm'>
          <CardTitle className='p-2'>
            <div className="flex items-center gap-2">
              <ArrowUp10 size={34} className="text-muted-foreground" />
              <p className="text-base font-narrow">Contagem de Negócios (mensais): </p>
            </div>

          </CardTitle>
          <CardContent className='h-max flex items-end justify-end'>
            <p className='text-5xl pr-6 font-anton'>{contagem}</p>
          </CardContent>
        </Card>

        <Card className='rounded-lg border bg-card text-card-foreground shadow-sm'>
          <CardContent className="p-4">
            <div className="flex items-center gap-2">
              <CalendarDays className="text-muted-foreground" />
              <p className="text-sm font-medium">Soma da mensalidade (Mensais)</p>
            </div>
            <p className="text-3xl font-bold">R${sumMensalidade.toFixed(2)}</p>
            <p className={percentMens != undefined && percentMens < 0 ? "text-xs text-red-600 mt-1" : "text-xs text-green-600 mt-1"}>{!isNaN(Number(percentMens))
        ? `${Number(percentMens)}% comparado ao mês passado`
        : percentMens}</p>
          </CardContent>
        </Card>

        <Card className='rounded-lg border bg-card text-card-foreground shadow-sm'>
          <CardContent className="p-4">
            <div className="flex items-center gap-2">
              <DollarSign className="text-muted-foreground" />
              <p className="text-sm font-medium">Soma das implantações (Mensais)</p>
            </div>
            <p className="text-3xl font-bold">R${sumImplantacao.toFixed(2)}</p>
            <p className={percentImplant != undefined && percentImplant < 0 ? "text-xs text-red-600 mt-1" : "text-xs text-green-600 mt-1"}>{!isNaN(Number(percentImplant))
        ? `${Number(percentImplant)}% comparado ao mês passado`
        : percentImplant}</p>
          </CardContent>
        </Card>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card className="flex flex-col">
          <CardHeader className="items-center pb-0">
            <CardTitle>Categorias de Negócio</CardTitle>
            <CardDescription>{months[month]} - {year}</CardDescription>
          </CardHeader>
          {loading ? (
            <div className="flex justify-center w-full h-full">
              <Skeleton className="bg-gray-700 h-[80%] w-[80%] p-8 rounded-xl" />
            </div>
      ) : (<CardContent className="flex-1 pb-0">
            <ChartContainer
              config={chartConfig}
              className="mx-auto aspect-square max-h-[250px]"
            >
              <PieChart>
                <ChartTooltip cursor={false} content={<ChartTooltipContent hideLabel />} />
                <Pie
                  data={chartData}
                  dataKey="count"
                  nameKey="description"
                  innerRadius={60}
                  strokeWidth={5}
                >
                  {chartData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLOR_BY_DESCRIPTION[entry.description] || "#8884d8"} />
                  ))}
                  <Label
                    content={({ viewBox }) => {
                      if (viewBox && "cx" in viewBox && "cy" in viewBox) {
                        return (
                          <text x={viewBox.cx} y={viewBox.cy} textAnchor="middle" dominantBaseline="middle">
                            <tspan x={viewBox.cx} y={viewBox.cy} className="fill-foreground text-3xl font-bold">
                              {contagem}
                            </tspan>
                            <tspan x={viewBox.cx} y={(viewBox.cy || 0) + 24} className="fill-muted-foreground">
                              Negócios
                            </tspan>
                          </text>
                        );
                      }
                    }}
                  />
                  
                </Pie>
                <Legend />
              </PieChart>
            </ChartContainer>
          </CardContent>)}
        </Card>
        <Carousel
          plugins={[
            Autoplay({
              delay: 10000,
            }),
          ]}
          className="relative"
          opts={{
            align: "start",
            loop: true,
          }}>
          <CarouselContent>
            <CarouselItem key={1}>
              <Card className="rounded-lg border bg-card text-card-foreground shadow-sm md:col-span-1">
          <CardHeader>
            <CardTitle>Pipeline (Total mensalidade Mês)</CardTitle>
          </CardHeader>
          {loading ? (<div className="flex justify-center w-full h-[250px]">
              <Skeleton className="bg-gray-700 h-[80%] w-[80%] p-8 rounded-xl" />
            </div>): (<CardContent className="flex flex-col w-[100%] gap-6 items-start">
            <ResponsiveContainer width="100%" height={160}>
              <BarChart
                data={pipelineDataF}
                layout="vertical"
                margin={{ top: 10, right: 0, left: 0, bottom: 10 }}
                barSize={20}
              >
                <XAxis type="number" hide />
                <YAxis dataKey="description" type="category" width={0} />
                <Tooltip content={CustomTooltip} />
                <Bar dataKey="totalPrice" label="Valor total">
                  {pipelineDataF.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLOR_BY_DESCRIPTION[entry.description] || "#8884d8"} />

                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
            <div className="flex flex-col w-[100%] ">
              {pipelineDataF.map((stage, index) => (
                <div key={index} className="text-base flex justify-between justify-between h-full">
                  <div>{stage.description}</div>
                  <div>{stage.count} Negócio - <span className="font-medium">R${stage.totalPrice.toFixed(2).toLocaleString()}</span></div>
                </div>
              ))}
            </div>
          </CardContent>)}
        </Card>
            </CarouselItem>
            <CarouselItem key={2}>
              <Card className="rounded-lg border bg-card text-card-foreground shadow-sm md:col-span-1">
          <CardHeader>
            <CardTitle>Pipeline (Total Implantação Mês)</CardTitle>
          </CardHeader>
          {loading ? (<div className="flex justify-center w-full h-[250px]">
              <Skeleton className="bg-gray-700 h-[80%] w-[80%] p-8 rounded-xl" />
            </div>) : (<CardContent className="flex flex-col w-[100%] gap-6 items-start">
            <ResponsiveContainer width="100%" height={160}>
              <BarChart
                data={pipelineDataF}
                layout="vertical"
                margin={{ top: 10, right: 0, left: 0, bottom: 10 }}
                barSize={20}
              >
                <XAxis type="number" hide />
                <YAxis dataKey="description" type="category" width={0} />
                <Tooltip content={CustomTooltipDeploy}/>
                <Bar dataKey="totalDeploy" label='Valor Implant'>
                  {pipelineDataF.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLOR_BY_DESCRIPTION[entry.description] || "#8884d8"} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
            <div className="flex flex-col w-[100%] ">
              {pipelineDataF.map((stage, index) => (
                <div key={index} className="text-base flex justify-between justify-between h-full">
                  <div>{stage.description}</div>
                  <div>{stage.count} Negócio - <span className="font-medium">R${stage.totalDeploy.toFixed(2).toLocaleString()}</span></div>
                </div>
              ))}
            </div>
          </CardContent>)}
        </Card>
            </CarouselItem>
          </CarouselContent>
        </Carousel>
        <Carousel
          plugins={[
            Autoplay({
              delay: 2000,
            }),
          ]}
          className="relative"
          opts={{
            align: "start",
            loop: true,
          }}>
          <CarouselContent>
            <CarouselItem key={1}>
              <Card className="rounded-lg border bg-card text-card-foreground shadow-sm md:col-span-1">
               {loading? (<div className="flex justify-center w-full h-[250px] mt-6">
              <Skeleton className="bg-gray-700 h-[80%] w-[80%] p-8 rounded-xl" />
            </div>) : ( <CardContent className="p-5">
                  <p className="font-medium mb-2">Negócios Pendentes</p>
                  <div className="border p-3 mb-2 rounded-md flex justify-between items-center">
                    <p className="font-semibold text-xl">Negócios Não Atendidos</p>
                    <p className="text-3xl font-anton text-red-400">{atrasados}</p>
                  </div>
                  <div className="border p-3 mb-2 rounded-md flex justify-between items-center">
                    <p className="font-semibold text-xl">Negócios c/ Aprovação Pendente</p>
                    <p className="text-3xl font-anton text-green-400">{pendentes}</p>
                  </div>
                  <div className="border p-3 mb-2 rounded-md flex justify-between items-center">
                    <p className="font-semibold text-xl">Aprovados (atrasados)</p>
                    <p className="text-3xl font-anton text-red-400">{lateAprovados}</p>
                  </div>
                  <div className="border p-3 mb-2 rounded-md flex justify-between items-center">
                    <p className="font-semibold text-xl">Rejeitados (atrasados)</p>
                    <p className="text-3xl font-anton text-red-400">{lateRejeitados}</p>
                  </div>
                  <div className="border p-3 mb-2 rounded-md flex justify-between items-center">
                    <p className="font-semibold text-xl">Declinados (atrasados)</p>
                    <p className="text-3xl font-anton text-orange-400">{lateRejeitados}</p>
                  </div>
                </CardContent>)}
              </Card>
            </CarouselItem>
            <CarouselItem key={2}>
              <Card className=" rounded-lg border bg-card text-card-foreground shadow-sm md:col-span-1">
                {loading? (<div className="flex justify-center w-full h-[250px] mt-6">
              <Skeleton className="bg-gray-700 h-[80%] w-[80%] p-8 rounded-xl" />
            </div>) : (<CardContent className="p-4 space-y-4">
                  <p className="font-medium">Negócios Finalizados No Mês</p>
                  <div className="space-y-2">
                    <div className="border p-3 rounded-md flex justify-between items-center">
                      <p className="font-semibold text-xl">Negócios Cancelados</p>
                      <p className="text-3xl font-anton text-red-600">{cancelados}</p>
                    </div>
                    <div className="border p-3 rounded-md flex justify-between items-center">
                      <p className="font-semibold text-xl">Negócios Aprovados</p>
                      <p className="text-3xl font-anton text-green-600">{aprovados}</p>
                    </div>
                    <div className="border p-3 rounded-md flex justify-between items-center">
                      <p className="font-semibold text-xl">Negócios Declinados</p>
                      <p className="text-3xl font-anton text-orange-600">{declinados}</p>
                    </div>
                  </div>
                </CardContent>)}
              </Card>
            </CarouselItem>
          </CarouselContent>
        </Carousel>
      </div>
    </div>
  );
}